import type { ComponentProps } from 'react';

import { OnboardingStepLayout } from '../OnboardingStepLayout';

export const MarketGuidanceLayout = (
  props: ComponentProps<typeof OnboardingStepLayout>
) => {
  return <OnboardingStepLayout {...props} />;
};
